// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_1HLkvM0BBk0oE6JxlQCoRP","list":"_12ixjDeiUojMqG6IYthKHh","schoolItem":"_2WaShbsNjvF82Gd_q-k53O","createButton":"AXsVH9E6m9VdYV1YN3XZj"};